export default function isMouseEvent (eventName) {
	return [
		'click',
		'contextmenu',
		'dblclick',
		'mousedown',
		'mouseenter',
		'mouseleave',
		'mousemove',
		'mouseout',
		'mouseover',
		'mouseup'
	].some(mouseEvent => eventName === mouseEvent || eventName === `on${mouseEvent}`);
};
